import { __assign, __rest } from "tslib";
import React, { useRef } from 'react';
var VeltCommentDialogContextWrapper = function (props) {
    var annotationId = props.annotationId, children = props.children, restProps = __rest(props, ["annotationId", "children"]);
    var ref = useRef(null);
    // Convert camelCase props to kebab-case attributes for custom element
    var customAttributes = {};
    Object.keys(restProps).forEach(function (key) {
        // Skip React-specific props
        if (['className', 'style', 'id', 'ref', 'key'].includes(key)) {
            return;
        }
        // Convert camelCase to kebab-case
        var kebabKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        var value = restProps[key];
        if (value !== undefined && value !== null) {
            customAttributes[kebabKey] = typeof value === 'object' ? JSON.stringify(value) : String(value);
        }
    });
    return (React.createElement("velt-comment-dialog-context-wrapper", __assign({ ref: ref, "annotation-id": annotationId }, customAttributes), children));
};
export default VeltCommentDialogContextWrapper;
